export default __webpack_public_path__ + "static/media/Eye_3_M_C6.db3e1e8a.svg";